import type { ReactNode } from 'react';

/** A one-line aside under a page header that explains the scope being shown. */
export function ScopeNote({ children }: { children: ReactNode }) {
  return (
    <p
      style={{
        margin: 0,
        padding: '8px 12px',
        borderRadius: 8,
        border: '1px dashed var(--nb-border-2)',
        background: 'var(--nb-bg)',
        fontSize: 12,
        color: 'var(--nb-muted)',
      }}
    >
      {children}
    </p>
  );
}

export const NO_REGIONS_NOTE = 'No regions are assigned to you — showing all regions.';
